export default __webpack_public_path__ + "static/media/Flamefuse Helm.38d19e0c.jpg";